import React, { useContext } from 'react';
import EvaluationContext from '../../context/evaluation/evaluationContext';
import centroenlace from '../../img/centroenlace.jpg';

function ListaEvaluaciones() {
    
    const evaluationContext = useContext(EvaluationContext);
    const { evaluaciones } = evaluationContext;

    const Pregunta = (props) => {
        const { question, answer, comment } = props;
        return (
            <>
                <div className="form-row" key={props.n} >
                    <div className="form-group col-md-1"></div>
                    <div className="form-group col-md-10">
                        <span dangerouslySetInnerHTML={{__html: question}}></span>
                        <br/>
                        <div className="btn-group" role="group" aria-label="Basic radio toggle button group" >
                            <label className="btn btn-outline-primary" >Puntuación: {answer}</label>
                        </div>
                        { comment && (
                            <p><i>{comment}</i></p>
                        )}
                    </div>
                </div>
            </>
        )
    }
    
    const EvaluacionResumen = (props) => {
        const { title, questions } = props.row.formulario;
        const { comments, duration, expectatives, final_question, meeting_date, scores } = props.row.evaluacion;
        

        return (
            <div className="card" key={props._id}>
                <div className="card-header border-bottom">
                    <h3 className="m-0">{title}</h3>
                </div>
                <div className="card-body">
                    <div className="card-text">
                        <div className="row">

                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <ul className="list-group list-group-flush">
                                    <li className="list-group-item p-3">
                                        <div className="row">
                                            <div>
                                                <img src={centroenlace} className="logo-centro-enlace" alt="logo" />
                                            </div>
                                        </div>
                                        <div className="row">            
                                            <div className="col">
                                            
                                                <h5>A. Aspectos Generales</h5>
                                                <div className="form-row">
                                                    <div className="form-group col-md-1"></div>
                                                    <div className="form-group col-md-2">
                                                        <label htmlFor="meeting_date">Fecha:</label>
                                                    </div>
                                                    <div className="form-group col-md-3">
                                                        <p><i>{meeting_date}</i></p>
                                                    </div>
                                                    <div className="form-group col-md-2">
                                                        <label htmlFor="duration">Duración de la reunión:</label>                                                    
                                                    </div>
                                                    <div className="form-group col-md-3">
                                                        <p><i>{duration}</i></p>
                                                    </div>
                                                </div>
                                                
                                                <h5>B. Percepción General</h5>
                                                
                                                <div>
                                                    <p><b>Calificación de 1 a 7</b> de los siguientes aspectos según el grado de satisfacción, donde 1 es muy insatisfecho y 7 es muy satisfecho.</p>
                                                </div>
                                                
                                                { questions.map((item, index) => {
                                                        return(
                                                            <Pregunta n={index} key={index} question={item.q} answer={scores[index]} comment={comments[index]}/>
                                                        );
                                                    })
                                                }
                                                
                                                <h5>C. Expectativas</h5>
                                                <div className="form-row">
                                                    <div className="form-group col-md-1"></div>
                                                    <div className="form-group col-md-10">
                                                        <p><i>{expectatives}</i></p>
                                                    </div>
                                                </div>

                                                { final_question && (
                                                    <>
                                                        <h5>D. Pregunta Final</h5>
                                                        <div className="form-row">
                                                            <div className="form-group col-md-1"></div>
                                                            <div className="form-group col-md-10">
                                                                <p><i>{final_question}</i></p>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <>
        { evaluaciones ? (
            <div className="container">
                <div className="row">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                    { evaluaciones?.length === 0 ? (
                        <div className="card">
                            <div className="card-header border-bottom">
                                <h3 className="m-0">Lista de evaluaciones</h3>
                            </div>
                            <div className="card-body">
                                <div className="card-text">
                                    <div className="row">

                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                <h4>Este usuario no cuenta con evaluaciones realizadas</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        ) : (
                            evaluaciones?.map ((row) => (
                                <>
                                    <EvaluacionResumen row={row} key={row.evaluacion._id} />
                                    <br/>
                                </>
                            ))
                        )}
                    </div>
                </div>
            </div> 
        ) : (
            <h1>Cargando</h1>
        )}
        </>
    )
}

export default ListaEvaluaciones